import { render, staticRenderFns } from "./BlogCategory.vue?vue&type=template&id=752dc1d1&scoped=true&"
import script from "./BlogCategory.vue?vue&type=script&lang=js&"
export * from "./BlogCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752dc1d1",
  null
  
)

export default component.exports